import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
`;

// eslint-disable-next-line import/prefer-default-export
export { Container };
